import axios from "axios";

const FOR_TELEGRAM_API = axios.create({
    baseURL: "https://mw.tvcom.uz",
});

export const loginTg = async (initData) => {
    try {
        const res = await FOR_TELEGRAM_API.get("/billing/api/telegram/login", {
            params: {
                init_data: initData,
            },
        });
        return res;
    } catch (error) {
        return error;
    }
};
